export enum UserSegment {
  RETAIL = 'RETAIL',
  INSTITUTIONAL = 'INSTITUTIONAL',
  MARKET_MAKER = 'MARKET_MAKER',
}
